import React from 'react';
import HomeEcosystemHero from '../components/HomeEcosystemHero';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';

const HomeEcosystemPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <main>
        <HomeEcosystemHero />
        
      </main>
    </div>
  );
};

export default HomeEcosystemPage;